"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledBox = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _BoxMixin = require("../../mixins/components/BoxMixin");
var StyledBox = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledBox",
  componentId: "c11n-8-107-0__sc-ocjv7k-0"
})(["", ""], _BoxMixin.BoxMixin);
exports.StyledBox = StyledBox;